<template>
  <ExActionsPopUp
    :value="show"
    headline="Delete Department"
    :icon="'department_icon'"
    :htmlInfo="info"
    :destructive="true"
    actionLabel="Delete"
    :centerHeadline="true"
    actionsTopSpacing="32px"
    @onAction="$emit('onDelete')"
    @input="$emit('onClose')"
    data-testid="delete-department-popup"
    :applyBorderClass="true"
    :backgroundPatternBottomRight="true"
    :width="450"
  >
  </ExActionsPopUp>
</template>
<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    default: "",
  },
});

defineEmits(["onDelete", "onClose"]);

const formattedInfo = computed(() => {
  return `<div style="max-width: 284px; margin: 0 auto; margin-top: 26px;">You are about to delete Department ${props.name}. This action is irreversible.</div>`;
});

const info = computed(() => {
  return formattedInfo.value;
});
</script>
